/* eslint-disable @typescript-eslint/no-unsafe-call */
// 因为QualityContent内容还被无标签复用，保障路由组件与路由组件之间解耦
// 同时，确保不同的路有bundle之间没有直接依赖
import {
  Component, InjectReactive, Mixins,
} from 'vue-property-decorator';
import { Route } from 'vue-router';

import isPrerendering from '@/shared/utils/isPrerendering';
import AdvertDialog from '@/mixins/advert-dialog';
import { setIosBouncesEable } from '@/api/native';
import platform from '@/shared/utils/platform';
import wechat from '@/api/native/wechat';
import { HOME_ALL_VERSION_ROUTE_PATHS } from '@/router/utils';
import { RouterV2Enum } from '@/router/router-names';
import RouterHelper from '@/shared/utils/routerHelper';
import type { Home } from '../../types';
import HomeWrapper from '../home-wrapper';
import QualityContent from './quality-content';

const _isPrerendering = isPrerendering();

@Component
export default class AppQualityHome extends Mixins(
  AdvertDialog,
) {
  @InjectReactive() homePage!: Home;

  private async beforeRouteLeave(to: Route, from: Route, next: (d?: unknown) => void) {
    this.$ubtPageButton(
      'finance_qualityHomePage_outTime',
      'currentOutTime',
      `${new Date().getTime()}`,
    );

    // 检查快速提现卡片弹窗是否显示，如果显示则关闭并拦截路由
    const qualityContent = this.$refs.qualityContent as {
      checkAndCloseQuickWithdrawCard?: () => Promise<boolean>;
    } | undefined;

    if (qualityContent && typeof qualityContent.checkAndCloseQuickWithdrawCard === 'function') {
      /** 首页的这些路由，才执行检查快速提现卡片弹窗是否显示，如果显示则关闭并拦截路由 */
      if (HOME_ALL_VERSION_ROUTE_PATHS.includes(to.path as RouterV2Enum)) {
        const hasClosed = await qualityContent.checkAndCloseQuickWithdrawCard();
        if (hasClosed) {
        // 如果关闭了弹窗，拦截路由跳转
          RouterHelper.useNextFalse(next);
          return;
        }
      }
    }

    // 检查 HomeWrapper 中的 UpgradeWrapper（如果有）
    const homeWrapper = this.$refs.homeWrapper as {
      checkAndCloseQuickWithdrawCard?: () => Promise<boolean>;
    } | undefined;

    if (homeWrapper && typeof homeWrapper.checkAndCloseQuickWithdrawCard === 'function') {
      /** 首页的这些路由，才执行检查快速提现卡片弹窗是否显示，如果显示则关闭并拦截路由 */
      if (HOME_ALL_VERSION_ROUTE_PATHS.includes(to.path as RouterV2Enum)) {
        const hasClosed = await homeWrapper.checkAndCloseQuickWithdrawCard();
        if (hasClosed) {
          // 如果关闭了弹窗，拦截路由跳转
          RouterHelper.useNextFalse(next);
          return;
        }
      }
    }

    // 离开页面时，设置ios可以弹性滚动
    setIosBouncesEable(true);

    /**
     * 如果需要对路由进行矫正，则不作做拦截；
     */
    if (this.homePage && this.homePage.shouldCorrectRouteByCredit()) {
      next();
    } else {
      this.controlPopVisible(
        to,
        from,
        next,
        platform.isWechatMini || this.homePage?.getIsUpgradeProcessingAndCredited(),
      );
    }
  }

  private mounted() {
    if (!_isPrerendering) {
      this.$ubtPageButton(
        'finance_qualityHomePage_inTime',
        'currentInTime',
        `${new Date().getTime()}`,
      );

      // 设置ios弹性滚动禁止
      setIosBouncesEable(false);
    }
  }

  private render() {
    return (
      <HomeWrapper ref="homeWrapper">
        <QualityContent ref="qualityContent" />
        {/* 主要用于命中用户返回的时候显示广告弹窗，见：popup.tsx */}
        {!_isPrerendering && this.renderAdvertDialog()}
      </HomeWrapper>
    );
  }
}
